import * as React from "react";
const SvgFiRrInvest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.501 7.205a1 1 0 1 0-1.002 1.732A7.03 7.03 0 0 1 19 15.001c0 1.57-.52 3.021-1.396 4.19L13 14.587V3l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.414.586a2 2 0 0 0-2.828 0L8.293 2.879a.999.999 0 1 0 1.414 1.414L11 3v3.056c-4.494.499-8 4.32-8 8.944 0 4.963 4.038 9 9 9s9-4.037 9-9a9.03 9.03 0 0 0-4.499-7.795M5 15c0-3.52 2.612-6.442 6-6.928v6.514c0 .526.213 1.042.586 1.414l4.604 4.604A6.97 6.97 0 0 1 12 22c-3.86 0-7-3.141-7-7"
    />
  </svg>
);
export default SvgFiRrInvest;
